export const CHOIX_SOUS_TYPE_BAILLEUR = {
  title: 'Type de bailleurs',
  breadcrumb: {
    liste: 'Liste des bailleurs',
    racine: 'Accueil',
  },
  sousTypes: {
    pro: 'Professionnel',
    prive: 'Particulier',
    concession: 'Concession',
    administrationEtAssimilee: 'Administration et assimilée',
  },
};

export const AJOUT_BAILLEUR = {
  title: {
    ajout: 'Création d\'un bailleur ',
    edit: 'Modification du bailleur ',
  },
  sousTypes: {
    prive: 'particulier',
    pro: 'professionnel',
    concession: 'concession',
    administrationEtAssimilee: 'administration et assimilée',
  },
  breadcrumb: {
    ajout: 'Création bailleur',
    edit: 'Modification bailleur',
    racine: 'Accueil',
    liste: 'Liste des bailleurs',
  },
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    raisonSocial: 'Le champ \'raison social\' est obligatoire.',
    nom: 'Le champ \'nom\' est obligatoire.',
  },
  avertissement: {
    title: 'Attention, l\'IBAN et/ou le BIC du bailleur ont un problème ',
    iban: {
      length: 'La longueur de l\'IBAN n\'est pas correct',
      countryCodeUnsupported: 'Le code de pays de l\'IBAN n\'est pas supporté',
      countryCodeUpperCaseLetters: 'Le code du pays de l\'IBAN doit-être en majuscule',
      invalidCheckDigitValue: 'Les chiffres de contrôle d\' l\'IBAN sont invalides',
      genericError: 'IBAN incorrect : {code}',
    },
    bic: {
      length: 'Le bic doit contenir 8 caractères ou 11 caractères',
      branchCodeOnlyLettersOrDigit: 'Le code de la branche doit contenir seulement des lettres ou des chiffres',
      countryCodeUnsupported: 'Le code de pays du BIC n\'est pas supporté',
      genericError: 'BIC incorrect : {code}',
    },
  },
  informationsGenerales: {
    title: 'Informations générales',
    code: 'Code',
    raisonSociale: 'Raison sociale',
    email: 'Email',
    telephoneFixe: 'Téléphone fixe',
    telephonePortable: 'Téléphone portable',
    civilite: 'Civilité',
    nom: 'Nom',
    role: 'Rôle',
    prenom: 'Prénom',
    siret: 'Siret',
    type: 'Type',
    dateNaissance: 'Date de naissance',
    nomJeuneFille: 'Nom de jeune fille',
    applicationTva: 'Application TVA',
  },
  adresse: {
    title: 'Adresses',
    postalAddress: 'Adresse postale',
    addressBillingDifferent: 'Adresse de facturation différente de l\'adresse postale.',
  },
  contact: {
    title: 'Contacts',
    haveAddress: 'Adresse postale différente du bailleur',
  },
  informationsBancaires: {
    title: 'Informations bancaires',
    libelleBanque: 'Libellé banque',
    titulaire: 'Titulaire',
    IBAN: 'IBAN',
    BIC: 'BIC',
    modePaiement: 'Mode de paiement',
    ordreCheque: 'Ordre de chèque',
  },
  infoComptable: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable',
    referenceUniqueMandat: 'Référence unique mandat',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA',
  },
  infoBlocagePaiement: {
    title: 'Bloquer paiement',
    bloquePaiement: 'Bloquer paiement',
    bloque: 'Bloquer',
    motif: 'Motif de blocage',
  },
  commentaire: {
    title: 'Commentaires',
    commentaire: 'Commentaire',
  },
  notifications: {
    successCreation: 'Création du bailleur réalisée avec succès.',
    successChange: 'Modification du bailleur réalisée avec succès.',
  },
  retrocession: {
    title: 'Rétrocession',
    pourcentageRetrocession: 'Pourcentage de rétrocession %',
  },
};

export const DETAIL_BAILLEUR = {
  title: 'Détail {nom}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des bailleurs',
    detail: 'Détail bailleur',
  },
  actions: {
    edit: 'Modifier',
    contrat: 'Baux',
    newBail: 'Nouveau bail',
  },
  titleAccesRapide: 'Accès rapide',
  tab: {
    bailleur: 'Bailleur',
    baux: 'Baux',
    faces: 'Faces',
    ecranNumeriques: 'Ecrans',
    compte: 'Compte',
    encours: 'Encours bailleur',
  },
  steps: {
    infoGenerales: 'Informations générales',
    contacts: 'Contacts',
    infoBancaire: 'Informations bancaires',
    commentaires: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
  informationsGenerales: {
    title: 'Informations générales',
    infoAdministrative: 'Informations administrative',
    siret: 'Siret :',
    coordonees: 'Coordonnées',
    email: 'Email :',
    telFixe: 'Téléphone fixe :',
    telPortable: 'Téléphone portable :',
    adresses: 'Adresses',
    adresse: 'Adresse',
    adressePostale: 'Adresse postale :',
    adressePaiement: 'Adresse de paiement :',
    estMairie: 'Mairie',
    infoComplementaire: 'Informations complémentaires',
    dateNaissance: 'Date de naissance :',
    nomJeuneFille: 'Nom de jeune fille :',
    applicationTva: 'Application TVA :',
  },
  contacts: {
    title: 'Contacts',
  },
  infoBancaire: {
    title: 'Informations bancaires',
    libelleBanque: 'Libellé banque :',
    titulaire: 'Titulaire :',
    iban: 'IBAN :',
    bic: 'BIC :',
    modePaiement: 'Mode de paiement :',
    ordreCheque: 'Ordre de chèque :',
  },
  infoCompta: {
    title: 'Informations comptables',
    compteComptable: 'Compte comptable :',
    referenceUniqueMandat: 'Référence unique mandat :',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA :',
  },
  infoBlocagePaiement: {
    title: 'Bloquer paiement',
    bloquePaiement: 'Bloquer paiement :',
    motif: 'Motif de blocage :',
  },
  commentaires: {
    title: 'Commentaires',
  },
  piecesJointes: {
    title: 'Pièces jointes',
  },
  messages: {
    suppressionDone: 'Le contact a bien été supprimé',
  },
  retrocession: {
    title: 'Rétrocession',
    pourcentageRetrocession: 'Pourcentage de rétrocession :',
  },
  libelleForLogo: 'Bailleur {nomCommercial}',
};
export const LISTE_BAILLEUR = {
  title: 'Liste des bailleurs',
  breadcrumb: {
    home: 'Accueil',
    listeBailleur: 'Liste des bailleurs',
  },
  actions: {
    newBailleurs: 'Nouveau bailleur',
    delete: 'Supprimer',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  tab: {
    code: 'Code',
    type: 'Type',
    nom: 'Nom',
    adresse: 'Adresse',
    zipCode: 'CP',
    ville: 'Ville',
    telephone: 'Téléphone',
    email: 'Email',
    codeComptable: 'Code comptable',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
      archive: 'Archiver',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    bailleurs: 'Bailleur(s)',
    archive: 'Archivé',
    ville: 'Ville(s)',
    departement: 'Département (s)',
    codePostal: 'Code(s) postal(aux)',
    email: 'Email',
    telephone: 'Téléphone',
    type: 'Type(s)',
    motifBlocage: 'Motif(s) de blocage',
    blocageReglement: 'Blocage paiement',
    compteComptable: 'Compte comptable',
    yes: 'Oui',
    no: 'Non',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce bailleur ?',
    title: 'Etes-vous sûr de vouloir archiver ce bailleur ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Bailleur archivé avec succès',
    sucessDesarchivage: 'Bailleur désarchivé avec succès',
  },
  suppression: {
    title: 'Etes-vous sûr de vouloir supprimer ce bailleur ?',
    titleMulti: 'Êtes-vous sûr de vouloir supprimer ces bailleurs ?',
    errorDelete: 'Impossible de supprimer le bailleur "{nomCommercial}" car il est lié aux baux suivant : {codes}.',
    sucess: {
      bailleurDelete: 'Bailleur supprimé avec succès',
      bailleurMulti: 'Les bailleurs ont été supprimés avec succès.',
    },
  },
  sousType: {
    pro: 'Professionnel',
    consession: 'Concession',
    prive: 'Particulier',
    administrationEtAssimilee: 'Administration et assimilée',
  },
};

export const ECRAN_NUMERIQUE_BY_BAILLEUR = {
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher un écran',
  },
  tab: {
    codeMateriel: 'Code écran',
    dateMontage: 'Date montage',
    dateDemontage: 'Date démontage',
    etatMateriel: 'Etat écran',
    baux: 'Baux',
    disposition: 'Disposition',
    typeMateriel: 'Type de matériel',
    dispositifSupport: 'Support',
    dispositifType: 'Type de dispositif',
    adresse: 'Adresse',
    codeDispositif: 'Code dispositif',
    archive: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    code: 'Code(s)',
    codeDispositif: 'Code(s) dispositif',
    codeBail: 'Code(s) bail',
    codeMateriel: 'Code(s) écran',
    format: 'Format(s)',
    typeMateriel: 'Type(s) de matériel',
    typeDispositif: 'Type(s) de dispositif',
    typeSupport: 'Type(s) de support',
    etat: 'Etat(s)',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    au: ' au ',
    agglomerations: 'Agglomération(s)',
    dateMontage: 'Date de montage',
    dateDemontage: 'Date de démontage',
    actif: 'Actif',
    codePostal: 'Code(s) postal',
    actions: {
      search: 'Rechercher',
    },
  },
};
